/*
 * BUG FIX (Dec 2025): Prevent huge logo flash on product pages
 *
 * NOTE: JavaScript page-loading class approach REMOVED - didn't work because
 *       defer attribute means script runs AFTER the flash already happened
 *
 * CURRENT SOLUTION: Pure CSS max-width constraints in menu-drawer-fix.css
 *                   No JavaScript needed for logo sizing
 */

// Force header-scrolled class on product pages for consistent styling
if (document.body.classList.contains('product-template')) {
  document.addEventListener('DOMContentLoaded', function () {
    const headerTransparent = document.querySelector('.header-transparent');
    if (headerTransparent) {
      headerTransparent.classList.add('header-scrolled');
    }

    // Apply grid layout to Judge.me reviews after they load
    function applyReviewsGrid() {
      const reviewsContainer = document.querySelector('#judgeme_product_reviews');
      if (reviewsContainer) {
        // Ensure parent containers are NOT grid
        const mainWidget = reviewsContainer.querySelector('.jdgm-rev-widg');
        const bodyWrapper = reviewsContainer.querySelector('.jdgm-rev-widg__body');

        if (mainWidget) mainWidget.style.display = 'block';
        if (bodyWrapper) bodyWrapper.style.display = 'block';

        // Apply grid ONLY to the reviews wrapper
        const reviewsWrapper = reviewsContainer.querySelector('.jdgm-rev-widg__reviews');
        if (reviewsWrapper) {
          reviewsWrapper.style.display = 'grid';
          reviewsWrapper.style.gridTemplateColumns =
            window.innerWidth >= 1024
              ? 'repeat(3, 1fr)'
              : window.innerWidth >= 768
                ? 'repeat(2, 1fr)'
                : '1fr';
          reviewsWrapper.style.gap =
            window.innerWidth >= 1024 ? '1.5rem' : window.innerWidth >= 768 ? '1.25rem' : '1rem';
        }
      }
    }

    // Try immediately and after delays
    applyReviewsGrid();
    setTimeout(applyReviewsGrid, 500);
    setTimeout(applyReviewsGrid, 1000);
    setTimeout(applyReviewsGrid, 2000);

    // Watch for Judge.me widget to load
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          applyReviewsGrid();
        }
      });
    });

    const reviewsSection = document.querySelector('#judgeme_product_reviews');
    if (reviewsSection) {
      observer.observe(reviewsSection, { childList: true, subtree: true });
    }

    // Reapply on window resize
    window.addEventListener('resize', applyReviewsGrid);

    // Fixed: Cleanup on page unload
    window.addEventListener('pagehide', function () {
      observer.disconnect();
      window.removeEventListener('resize', applyReviewsGrid);
    });
  });
}
